import axios from 'axios'

const baseURL = process.env.VUE_APP_CYLINDER_SERVICE + '/api/admin/blogs'
const imageURL = process.env.VUE_APP_CYLINDER_SERVICE + '/api/admin/images'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getBlogs ({
      state,
      commit
    }, filters) {
      return axios.get(baseURL, {
        params: filters
      })
    },
    async getBlog ({
      state,
      commit
    }, id) {
      return axios.get(baseURL + '/' + id, {})
    },
    async createBlog ({
      state,
      commit
    }, data) {
      return axios.post(baseURL, data)
    },
    async uploadImage ({
      state,
      commit
    }, formData) {
      return axios.post(imageURL, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    },
    async updateBlog ({
      state,
      commit
    }, data) {
      return axios.put(baseURL + '/' + data.id, data)
    }
  }
}
